import logoS from "../../assets/images/web-logo.png"

export const imagesLogo = {
    img: logoS,
}